import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, NotyService, ErrorHandlerService, UserService, AppService } from '@app/services';
import { AuthenticationMethod } from '@app/models';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-auth-email-confirmation',
  templateUrl: './auth-email-confirmation.component.html',
  styleUrls: ['../auth.scss'],
  standalone: false
})
export class AuthEmailConfirmationComponent implements OnInit {
  isLoading = false;
  email: string;
  password: string;
  referral: string;
  redirectUrl: string | null = null;
  private navigationState: { [k: string]: any };

  constructor(
    public appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private notyService: NotyService,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private errorHandlerService: ErrorHandlerService,
    private userService: UserService
  ) {
    this.navigationState = router.getCurrentNavigation()?.extras.state || {};
  }

  ngOnInit() {
    this.email = this.navigationState?.fromAuthRegister ? this.navigationState?.email : this.route.snapshot.queryParams.email;
    this.password = this.navigationState?.fromAuthRegister ? this.navigationState?.password : null;
    this.referral = this.navigationState?.fromAuthRegister ? this.navigationState?.referral : this.route.snapshot.queryParams.r;
    this.redirectUrl = this.navigationState?.redirectUrl || this.route.snapshot.queryParams.redirect || null;
    this.authenticationService.logout().subscribe();
  }

  submit() {
    // Redirects to enterprise or normal autentique navigation
    this.notyService.success(this.translateService.instant('notyService.emailVerificationSuccess'));
    if (this.navigationState.enterpriseToken) {
      this.authenticationService.login({ enterprise_token: this.navigationState.enterpriseToken }, AuthenticationMethod.Enterprise).subscribe({
        next: () => this.router.navigate([this.route.snapshot.queryParams.redirect || '/'], { replaceUrl: true, queryParams: this.route.snapshot.queryParams }),
        error: error => this.errorHandlerService.handle(error)
      });
    } else {
      this.isLoading = true;
      this.userService
        .getCurrentUser({ fetchPolicy: 'network-only' })
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: user => {
            if (user.name) {
              this.appService.navigateAfterAuth(this.redirectUrl || '/', this.router);
            } else {
              this.router.navigate(['/onboarding'], { state: { fromAuthRegister: true, redirectUrl: this.redirectUrl } });
            }
          }
        });
    }
  }
}
